// extracted by mini-css-extract-plugin
export default {"wrapper":"icon_wrapper__sKPM6","pointer":"icon_pointer__qXRBG"};